import SubmissionCardModalTermsOfService from './TermsOfService'
export default SubmissionCardModalTermsOfService
